import { BorderGridContainer, ContentTile, GridBox } from '@ahmdigital/ui';
import React from 'react';

import wellbeingClawImage from './images/wellbeing-claw.svg';

type CompareCoversCalloutProps = {
  cta: {
    text: string;
    url: string;
  };
};

const CompareCoversCallout = ({ cta }: CompareCoversCalloutProps) => {
  const data = {
    ctas: [
      {
        link: cta.url,
        linkText: cta.text,
        variant: 'flair',
      },
    ],
    image: {
      alt: 'finger pointing to tooth',
      src: wellbeingClawImage.src,
    },
    subtitle: 'Select the inclusions you want and check out cover options that suit your needs.',
    title: 'Choose your own hospital & extras',
  };

  return (
    <BorderGridContainer hideBorderTop>
      <GridBox padding="1rem">
        <ContentTile variant="fullWidth" {...data} />
      </GridBox>
    </BorderGridContainer>
  );
};

export default CompareCoversCallout;
